<div class="pagination pagination-rounded d-flex align-items-center justify-content-between my-2">
    <div class="page-item">
        <span>
            {{totalItemsText}}
            <strong>{{totalItems | async}}</strong>
        </span>
    </div>   
    <div class="page-item align-items-center">
        <pagination [maxSize]="25" [itemsPerPage]="itemsPerPage" [totalItems]="(totalItems | async)!" [(ngModel)]="page">
        </pagination>
    </div>
</div>